import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    padding: 15,
    paddingTop: 40,
    background: '#fff',
    boxShadow: '2px 5px 8px 0 rgba(112, 136, 210, 0.2)',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  btn: {
    minWidth: 'auto',
    padding: 4,
    background: '#f0f3f7',
    borderRadius: '50%',
  },
  closeBtn: {
    position: 'absolute',
    top: 5,
    right: 5,
  },
  closeIcon: {
    fontSize: '1.3rem',
    color: theme.custom.darkBlue,
  },
  subject: {
    margin: 0,
    marginBottom: 20,
    fontSize: 16,
    fontWeight: 600,
    color: theme.custom.darkBlue,
  },
  text: {
    margin: 0,
    marginBottom: 0,
    fontSize: 15,
    fontWeight: 400,
    color: theme.custom.darkBlue,
  },
  user: {
    margin: 0,
    marginBottom: 0,
    fontSize: 15,
    fontWeight: 600,
    color: theme.custom.darkBlue,
  },
  userRole: {
    margin: 0,
    fontSize: 15,
    fontWeight: 400,
    color: theme.custom.darkBlue,
  },
  logo: {
    display: 'block',
    maxWidth: 150,
    maxHeight: 150,
    [theme.breakpoints.down('xs')]: {
      margin: '0 auto',
    },
  },
  pdfTitle: {
    margin: 0,
    marginBottom: 15,
    fontSize: 18,
    color: theme.custom.darkBlue,
  },
  pdfPreviewImg: {
    display: 'block',
    maxWidth: 250,
    width: '100%',
    height: 'auto',
    boxShadow: '4px 1px 8px 6px rgb(112 136 210 / 20%)',
    cursor: 'pointer',
    transition: '.15s linear',
    '&:hover': {
      transform: 'scale(1.01)',
    },
    [theme.breakpoints.down('xs')]: {
      margin: '0 auto',
    },
  },
  video: {
    width: '100%',
    maxWidth: 560,
    minHeight: 315,
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
    [theme.breakpoints.down(475)]: {
      minHeight: 250,
    },
    [theme.breakpoints.down(400)]: {
      minHeight: 0,
    },
  },
}));
